import "./src/fonts.css";
/* eslint-disable */
console.log("🌎 Tastefully Made");
/* eslint-enable */
